import {Component, OnInit, Input, OnChanges, EventEmitter, Output} from '@angular/core';
import {NgModule} from '@angular/core';
import {MamAdminService} from "../service/mam_service.component";
import {TargetGroupModule} from "./target_group.component";
import {TargetDeviceModule} from "./target_device.component";
import {TargetUserModule} from "./target_user.component";
import {CommonModule} from "@angular/common";
import {BrowserModule} from "@angular/platform-browser";
import {HttpModule} from "@angular/http";
import {ButtonModule,DataTableModule,TabViewModule,PanelModule} from "primeng/primeng";
import {Logger, Options, Level } from "angular2-logger/core"; // ADD THIS
import {FormsModule} from "@angular/forms";
import {TranslatePipeMoudle} from "../translate/translate.module.pipe";


@Component({

selector: 'app-distribute-remove',
templateUrl: 'app_distribute_remove.component.html'
})

export class AppDistributeRemoveComponent implements OnInit,OnChanges {

  @Input() title:string;
  @Input() selectOfficeApp:any;
  @Input() company : any;
  @Input() change : number;
  selectedGroupList : any;
  selectedUserList : any;
  selectedDeviceList : any;
  setGroupTargetList : any = [];
  setDeviceTargetList : any = [];
  setUserTargetList : any = [];

  getPolicyTargetLists : any;
  @Output() canceling :EventEmitter<any> = new EventEmitter();

  constructor(private service : MamAdminService, private logger : Logger) {

  }

  ngOnInit(): void {

  }

  ngOnChanges(): void{

    this.logger.debug("change한 값들 : ", this.change);
    if(this.selectOfficeApp){
      this.setGroupTargetList = [];
      this.setDeviceTargetList = [];
      this.setUserTargetList = [];
      this.selectedGroupList = "";
      this.selectedUserList  = "";
      this.selectedDeviceList  = "";
    }
  }

  

  deployApp(app_id:number, type:any, command:string, list:any) {
	if(this.selectOfficeApp.appType == "IOS") {
		this.service.iosSuperviseDeployApp(app_id,type,command,list).subscribe(
	      value => { this.logger.debug("앱  푸쉬 결과" ,value) },
	      error => { this.logger.error("-- error : " + error); }
    )} else {
		this.service.deployApp(app_id,type,command,list).subscribe(
	      value => { this.logger.debug("앱  푸쉬 결과" ,value) },
	      error => { this.logger.error("-- error : " + error); }
	
	    )}
  }

  distribute(){
    let command  ="";
    //삭제 - APP_REMOVE   인스톨 - APP_INSTALL
    if(this.title.indexOf("배포")>-1 || this.title.indexOf("Distribution")> -1){
      command = "APP_INSTALL";
      alert("APP을 배포합니다.");
    }else if(this.title.indexOf("제거")>-1 || this.title.indexOf("Remove")>-1){
      command = "APP_REMOVE";
      alert("APP을 제거합니다.");
    }
	
    this.logger.debug("그룹 리스트 : " ,this.selectedGroupList);
    this.logger.debug("유저 리스트 : " ,this.selectedUserList);
    this.logger.debug("디바이스 리스트 : " ,this.selectedDeviceList);
    let list :any = [];
    let type : number;
    if(this.selectedGroupList && this.selectedGroupList.length > 0){
      type=0;
      this.selectedGroupList.forEach(item => {
        list.push(Number(item.id));
      });
      this.deployApp(this.selectOfficeApp.id,type,command,list);
    }

    list = [];
    if(this.selectedUserList && this.selectedUserList.length > 0){
      type=1;
      this.selectedUserList.forEach(item => {
        list.push(item.id);
      });
      this.deployApp(this.selectOfficeApp.id,type,command,list);
    }

    list = [];
    if(this.selectedDeviceList && this.selectedDeviceList.length > 0){
      type=2;
      this.selectedDeviceList.forEach(item => {
        list.push(item.id);
      });
      this.deployApp(this.selectOfficeApp.id,type,command,list);
    }

    this.canceling.emit(false);

  }

  cancel(){
    this.canceling.emit(false);
  }

}


@NgModule({
  imports: [CommonModule,BrowserModule,TargetGroupModule,TargetDeviceModule,TargetUserModule,BrowserModule,FormsModule,ButtonModule,BrowserModule,HttpModule,DataTableModule,TabViewModule,PanelModule,TranslatePipeMoudle],
  exports: [AppDistributeRemoveComponent],
  declarations: [AppDistributeRemoveComponent],
  providers: [MamAdminService],
})
export class AppDistributeRemoveModule {
}



// WEBPACK FOOTER //
// ./src/app/component/app_distribute_remove.component.ts